export class UsuarioIntegradorModel {

    cliId: number;
    loginKosmos: string;
    fechaRegistro: string;
    estado: number;
    nombreCliente: string;
  
    constructor(
        cliId,
        loginKosmos,
        fechaRegistro?,
        estado?,
        nombreCliente?
                ) {
      this.cliId = cliId;
      this.loginKosmos = loginKosmos;
      this.fechaRegistro = fechaRegistro;
      this.estado = estado;
      this.nombreCliente = nombreCliente;
    }
  
  }